// Quais duas opções o Balcão mostra depois do Finalizar (pedido do dono,
// 29/09/2026): "restaurante" = Comer no Local / Para Viagem; "mercearia" =
// Levar agora / Entrega. O padrão vem da categoria do cadastro da loja e a loja
// troca em Configurações → Sistema → Preferências (GET /settings/balcao-consumo).
// Enquanto carrega, ou se der erro, fica "restaurante" (como sempre foi).
// `entregaDisponivel` = Delivery ligado em Preferências → Módulos da loja.
import axios from "axios";
import { useEffect, useState } from "react";

export function useModoConsumo(ativo) {
  const [modo, setModo] = useState("restaurante");
  const [entregaDisponivel, setEntregaDisponivel] = useState(true);
  useEffect(() => {
    if (!ativo) return undefined;
    let vivo = true;
    axios.get("/api/settings/balcao-consumo", { headers: { Authorization: `Bearer ${localStorage.getItem("token") || ""}` } })
      .then(({ data }) => {
        if (!vivo) return;
        if (data?.efetivo) setModo(data.efetivo);
        setEntregaDisponivel(data?.entrega_disponivel !== false);
      })
      .catch(() => {});
    return () => { vivo = false; };
  }, [ativo]);
  return { modo, entregaDisponivel };
}
